<template>
    <div>
        <div class="mx-auto my-2 w-100">
            <h3>Виды работ</h3>
        </div>
        <div class="d-flex justify-content-end my-2">
            <b-button
                    v-b-modal.typeWorkModal
                    size="sm"
                    variant="success"
                    v-if="$can('create', 'workTypes')"
            >Создать тип работы
            </b-button>
        </div>
        <b-row class="my-2 align-items-center">
            <b-col cols="12" md="6" class="mb-2 mb-md-0">
                <b-input-group size="sm">
                    <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Введите для поиска"
                    ></b-form-input>
                </b-input-group>
            </b-col>
            <b-col cols="12" md="6">
                <div class="d-flex flex-wrap justify-content-md-end align-items-center">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                            class="my-0 mb-2 mb-md-0 mr-2"
                    ></b-pagination>
                    <div class="mb-2 mb-md-0">
                        <b-form-group
                                label="На странице"
                                label-cols="6"
                                label-size="sm"
                                label-for="perPageSelect"
                                class="mb-0 d-flex align-items-center"
                        >
                            <b-form-select
                                    v-model="perPage"
                                    id="perPageSelect"
                                    size="sm"
                                    :options="pageOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-table
                responsive="sm"
                :fields="fields"
                striped
                small
                :items="workTypes"
                :current-page="currentPage"
                :per-page="perPage"
                @filtered="onFiltered"
                :filter="filter"
                :tbody-tr-class="rowClass"
                sticky-header="80vh"
        >
            <template v-slot:cell(status)="data">
                <b-badge v-if="data.item.is_active === false" variant="secondary">Отключён</b-badge>
                <span v-else class="text-muted">—</span>
            </template>
            <template v-slot:cell(actions)="data">
                <i class="fas fa-pen text-center text-success mx-2"
                   @click="onEdit(data)"
                   v-if="$can('update', 'workTypes')"
                ></i>
                <i class="fas fa-trash-alt text-danger text-center mx-2"
                   @click="onDelete(data)"
                   v-if="$can('delete', 'workTypes')"
                ></i>
                <b-button
                        v-if="$can('update', 'workTypes')"
                        size="sm"
                        :variant="data.item.is_active === false ? 'outline-success' : 'outline-secondary'"
                        :title="data.item.is_active === false
                            ? 'Вернуть вид работы в договоры и новые отчёты'
                            : 'Скрыть вид работы из договоров и новых отчётов, сохранив историю'"
                        v-b-tooltip.hover
                        @click="changeStatus(data.item)"
                >
                    {{ data.item.is_active === false ? 'Сделать действующим' : 'Отключить' }}
                </b-button>
            </template>
        </b-table>
        <div class="d-flex justify-content-end">
            <b-modal id="typeWorkModal"
                     :title="isEdit ? `Редактирование работы` : `Создание работы`"
                     @ok="submit()"
                     @hide="clearForm()"
                     ok-title="Ок"
                     ok-variant="success"
                     cancel-title="Отмена"
                     cancel-variant="danger"
                     :ok-disabled="!Boolean(name) || !Boolean(measurement)"
                     no-close-on-backdrop
            >
                <label for="name">Имя работы</label>
                <b-form-input
                        v-model="name"
                        placeholder="Стрижка бобра"
                        id="name"
                        size="sm"
                        :state="Boolean(name)"
                ></b-form-input>
                <label for="measurement">Единица изменения</label>
                <b-form-input
                        v-model="measurement"
                        placeholder="Пог. см."
                        id="measurement"
                        size="sm"
                        :state="Boolean(measurement)"
                ></b-form-input>
                <label for="workGroup">Группа работ</label>
                <v-select
                        :options="workGroups"
                        v-model="workGroup"
                        :reduce="group => group.id"
                        label="name"
                        :filter="(options, search) => searchText(options, search, [`name`])"
                >
                </v-select>
                <b-button variant="info" size="sm" class="my-2" @click="showAddGroup"
                          v-if="$can('create', 'workGroups')">
                    Группы работ нет в списке
                </b-button>
            </b-modal>
            <b-modal id="deleteWorkType"
                     @ok="deleteWorkType"
                     ok-title="Ок"
                     ok-variant="success"
                     cancel-title="Отмена"
                     cancel-variant="danger"
            >
                <p class="my-4" v-if="workType">
                    Вы действительно хотите удалить работу <span class="text-danger">{{ workType.name }}</span> из системы?
                </p>
            </b-modal>
        </div>
        <CreateWorkGroup
                :show="addGroupModalShow"
                @hidden="hideAddGroup"
                @workGroupCreated="workGroupCreated"
        />
    </div>
</template>

<script>
    import searchText from "../../utils/searchText";
    import CreateWorkGroup from "../../components/CreateWorkGroup/CreateWorkGroup.vue";
    export default {
        computed: {
            workTypes() {
                return this.$store.state.workTypes;
            },
            workGroups() {
                return this.$store.state.workGroups;
            }
        },
        components: {
            CreateWorkGroup
        },
        data() {
            return {
                fields: [
                    {
                        key: `name`,
                        label: `Имя`,
                        sortable: true
                    },
                    {
                        key: `unit_of_measurement`,
                        label: `Единица измерения`
                    },
                    {
                        key: `group`,
                        label: `Группа`,
                        sortable: true
                    },
                    {
                        key: `group_name`,
                        label: `Имя группы`,
                        sortable: true
                    },
                    {
                        key: `status`,
                        label: `Состояние`
                    },
                    {
                        label: ``,
                        key: `actions`,
                        class: `work-types-actions`
                    }
                ],
                isEdit: false,
                measurement: null,
                name: null,
                workType: null,
                workGroup: null,
                addGroupModalShow: false,
                filter: null,
                perPage: 200,
                pageOptions: [5, 10, 15, 20, 100, 200],
                totalRows: 1,
                currentPage: 1,
                filterOn: []
            }
        },
        methods: {
            clearForm() {
                this.isEdit = false;
                this.name = null;
                this.measurement = null;
                this.workType = null;
                this.workGroup = null;
            },
            async deleteWorkType() {
                try {
                    await this.$store.dispatch(`deleteWorkType`, this.workType.work_id);
                    await this.$store.dispatch(`getWorkTypes`);
                } catch (error) {
                    this.$store.dispatch('showErrorModal',
                        error && error.response && error.response.data || 'Не удалось удалить вид работы');
                }
            },
            onDelete(data) {
                this.workType = data.item;
                this.$bvModal.show(`deleteWorkType`);
            },
            onEdit(data) {
                this.isEdit = true;
                this.workType = data.item;
                const {name, unit_of_measurement, group_id} = data.item;
                this.name = name;
                this.measurement = unit_of_measurement;
                this.workGroup = group_id;
                this.$bvModal.show(`typeWorkModal`);
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            async submit() {
                const {measurement, name, workType, workGroup} = this;
                const data = {
                    name,
                    unit_of_measurement: measurement,
                    work_id: workType?.work_id,
                    group_id: workGroup
                };
                const action = this.isEdit ? `editWorkType` : `createWorkType`;
                await this.$store.dispatch(action, data).then(() => {
                    this.clearForm();
                    this.$store.dispatch(`getWorkTypes`);
                }).catch(err => {
                    this.clearForm();
                    this.$store.dispatch(`showErrorModal`, err.response.data);
                });
            },
            async changeStatus(item) {
                try {
                    await this.$store.dispatch('setWorkTypeStatus', {
                        workId: item.work_id,
                        isActive: item.is_active === false
                    });
                    await this.$store.dispatch('getWorkTypes');
                } catch (error) {
                    this.$store.dispatch('showErrorModal',
                        error && error.response && error.response.data || 'Не удалось изменить состояние вида работы');
                }
            },
            rowClass(item) {
                return item && item.is_active === false ? 'work-types-row--disabled' : '';
            },
            searchText,
            showAddGroup() {
                this.addGroupModalShow = true;
            },
            hideAddGroup() {
                this.addGroupModalShow = false;
            },
            async workGroupCreated(createdGroupId) {
                await this.$store.dispatch(`getWorkGroups`);
                this.workGroup = createdGroupId;
                this.hideAddGroup();
            }
        },
        async mounted() {
            await this.$store.dispatch(`getWorkTypes`);
            this.totalRows = this.workTypes.length;
            this.$store.dispatch(`getWorkGroups`);
        },
        name: "WorkTypes"
    }
</script>

<style scoped>
::v-deep .work-types-row--disabled {
    opacity: .58;
}

::v-deep .work-types-actions {
    min-width: 255px;
    white-space: nowrap;
}
</style>
